import type { ReactNode } from 'react';
import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * La línea de ayuda de la maqueta, debajo de las pestañas: «ⓘ Las reglas son
 * límites que ningún precio puede pasar… ¿Cómo funcionan?». Una frase que dice
 * qué es lo que se está mirando y, al final, su acción (un enlace que abre más).
 */
export function LineaDeAyuda({
  children,
  accion,
  className,
}: {
  children: ReactNode;
  accion?: ReactNode;
  className?: string;
}) {
  return (
    <p
      className={cn(
        'flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-muted-foreground',
        className
      )}
    >
      <Info className="h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
      <span>{children}</span>
      {accion}
    </p>
  );
}
